"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BloodSignetAbilityHandler = exports.BloodSignetActorAbilityFactory = exports.BloodSignetAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class BloodSignetAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BloodSignet;
        this.__typeName = "BloodSignet";
    }
}
exports.BloodSignetAbilityArgs = BloodSignetAbilityArgs;
let BloodSignetActorAbilityFactory = class BloodSignetActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BloodSignet", "OneEnemies", 3);
    }
};
BloodSignetActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BloodSignet")
], BloodSignetActorAbilityFactory);
exports.BloodSignetActorAbilityFactory = BloodSignetActorAbilityFactory;
let BloodSignetAbilityHandler = class BloodSignetAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        // Player impacted by the Blood Signet needs to be healed to 100% in 3 turns or they are instantly killed.
        // Healing a player to 100% instantly removes the Signet.
        // If player is killed by the Blood Signet, the signet jumps to the next player.
        // If all other living players are at 100% health, the signet dissipates.
        // This is not a supernatural death, so Defer Death and other skills which prevent death can save you (though, the signet will still bounce to another player if you are saved by Defer Death).
        const [targetId] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetId,
            projectileType: "BloodSpiralMissle",
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Death", 150)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence: sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_1.BloodSignetEffectArgs,
                    supernatural: true,
                    onAppliedOrResisted: (sequence, _, applied) => sequence.push(new core_2.InstantVfxStepArgs(applied ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest")
                        : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "PulsingBlood"))
                });
            },
        });
    }
};
BloodSignetAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BloodSignet)
], BloodSignetAbilityHandler);
exports.BloodSignetAbilityHandler = BloodSignetAbilityHandler;
